import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, catchError, map, of, switchMap } from 'rxjs';

import { GuaranteeApplicationsService } from '../services/guarantee-applications.service';
import * as PrescriptionsActions from './prescriptions.actions';

export const fetchPrescriptionsEffect = createEffect(
  (actions$ = inject(Actions), guaranteeService = inject(GuaranteeApplicationsService)): Observable<Action> =>
    actions$.pipe(
      ofType(PrescriptionsActions.fetchPrescriptions),
      switchMap(action =>
        guaranteeService.searchGuaranteeApplications(action).pipe(
          map(pagedResponse => PrescriptionsActions.fetchPrescriptionsSuccess({ pagedResponse })),
          catchError(error => of(PrescriptionsActions.fetchPrescriptionsFailure({ error: error.message || 'Failed to fetch prescriptions' })))
        )
      )
    ),
  { functional: true }
);

export const prescriptionsEffects = [fetchPrescriptionsEffect];